import IPatientDetails from "../interfaces/IPatientDetails";
import IQuestion from "../interfaces/IQuestion";

const PatientAttributesQuestions: IQuestion<IPatientDetails>[] = [
	{
		id: "who-is-patient",
		question: "I am booking for",
		options: [
			{
				text: "Myself",
				value: true,
				color: "primary",
				order: 1,
				nextId: "self-is-new-or-existing-patient",
				key: "isPersonBooking",
			},
			{
				text: "Someone else",
				value: false,
				color: "secondary",
				order: 2,
				nextId: "someone-else-is-new-or-existing-patient",
				key: "isPersonBooking",
			},
		],
		isEntry: true,
		prevId: null,
		key: null,
	},
	{
		id: "someone-else-is-new-or-existing-patient",
		question: "They are",
		options: [
			{
				text: "An existing patient",
				value: false,
				color: "secondary",
				order: 2,
				nextId: "end",
				key: "isNewPatient",
			},
			{
				text: "A new patient",
				value: true,
				color: "primary",
				order: 1,
				nextId: "end",
				key: "isNewPatient",
			},
		],
		prevId: null,
		key: "isNewPatient",
	},
	{
		id: "self-is-new-or-existing-patient",
		question: "I am",
		options: [
			{
				text: "An existing patient",
				value: false,
				color: "secondary",
				order: 2,
				nextId: "end",
				key: "isNewPatient",
			},
			{
				text: "A new patient",
				value: true,
				color: "primary",
				order: 1,
				nextId: "end",
				key: "isNewPatient",
			},
		],
		prevId: null,
		key: "isNewPatient",
	},
];

export default PatientAttributesQuestions;
